/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Any_Tasty_Mule_ReapInputs */

const es_any_tasty_mule_reap = /** @type {(inputs: Any_Tasty_Mule_ReapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva ley · Agosto 2025`)
};

const gl_any_tasty_mule_reap = /** @type {(inputs: Any_Tasty_Mule_ReapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova lei · Agosto 2025`)
};

const en_any_tasty_mule_reap = /** @type {(inputs: Any_Tasty_Mule_ReapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New law · August 2025`)
};

/**
* | output |
* | --- |
* | "New law · August 2025" |
*
* @param {Any_Tasty_Mule_ReapInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const any_tasty_mule_reap = /** @type {((inputs?: Any_Tasty_Mule_ReapInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Any_Tasty_Mule_ReapInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_any_tasty_mule_reap(inputs)
	if (locale === "en") return en_any_tasty_mule_reap(inputs)
	return es_any_tasty_mule_reap(inputs)
});